import { CheckoutSegmentCategory } from "@redotech/redo-model/conversion/checkout-segments/checkout-segment-category";
import * as z from "zod/v4";

/**
 * Schema for getting segmented checkout metrics for an A/B test split
 */
export const getSegmentedCheckoutMetricsForSplit = {
  name: "getSegmentedCheckoutMetricsForSplit" as const,
  input: z.object({ splitId: z.string() }),
  output: z.object({
    segments: z.array(
      z.object({
        segmentKey: z.string(),
        name: z.string(),
        category: z.enum(CheckoutSegmentCategory),
        testStatus: z.enum(["control_leading", "potential_lift"]),
        totalCheckoutVisits: z.number(),
        totalCheckoutCompletions: z.number(),
        conversionRate: z.number(),
        aov: z.number(),
        winningTreatmentName: z.string(),
        controlConversionRate: z.number(),
        confidence: z.number(),
        revenuePerCheckoutVisit: z.number(),
        controlRevenuePerCheckoutVisit: z.number(),
        revenuePerCheckoutVisitLift: z.number(),
      }),
    ),
  }),
};
export type GetSegmentedCheckoutMetricsForSplitOutput = z.infer<
  typeof getSegmentedCheckoutMetricsForSplit.output
>;
